import { defineStore } from 'pinia';
import Service from '@/services/api/models/PlayerProfileRequestService';

export const usePlayerProfileRequestsStore = defineStore('playerProfileRequests', {
  state: () => ({ clubId: null, userId: null, rows: [], error: false, generation: 0 }),
  getters: {
    needsAttention: state => state.rows.some(row => ['action', 'result'].includes(row.state)),
    byPlayer: state => {
      const result = {};
      for (const row of state.rows) {
        const id = row.player.documentId;
        if (!result[id] || (result[id].state === 'waiting' && row.state !== 'waiting')) result[id] = row;
      }
      return result;
    },
  },
  actions: {
    reset() { this.generation++; this.clubId = null; this.userId = null; this.rows = []; this.error = false; },
    async refresh(clubId, userId) {
      if (!clubId) { this.reset(); return; }
      if (this.clubId !== clubId || this.userId !== userId) {
        this.rows = []; this.clubId = clubId; this.userId = userId;
      }
      const generation = ++this.generation;
      try {
        const rows = await Service.list(clubId);
        if (generation !== this.generation) return;
        this.rows = rows; this.error = false;
      } catch (_) {
        if (generation === this.generation) this.error = true;
      }
    },
  },
});
